import { useProgress } from "../../api/progressApi";
import { translator } from "../../utils/translator";
import "./progress.scss";

const progressOrder = {
  attitude: { unit: "점" },
  homework_score: { unit: "점" },
  e_learning: { unit: "분" },
  training_score: { unit: "점" },
  training_time: { unit: "분" },
  homework: { unit: "" },
  training: { unit: "" },
  docu_post: { unit: "" },
};

const StudentProgress = () => {
  const { data, isLoading } = useProgress();

  if (isLoading) return <p>로딩 중...</p>;
  return (
    <table>
      <tbody>
        {Object.entries(progressOrder).map(([progress, { unit }]) => (
          <tr key={progress} className="progress">
            <td>{translator[`progress_${progress}`]}</td>
            <td>
              {translator[data[progress].status || "empty"]}{" "}
              {unit &&
                !!data[progress].score_or_time &&
                `${data[progress].score_or_time}${unit}`}
            </td>
          </tr>
        ))}
        <tr key="total" className="progress">
          <td>Total</td>
          <td>{translator[data.total_status || "empty"]}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default StudentProgress;
